import Axios from "axios";
import { baseUrl } from "../../../config/url-config/index";
import { getDataLogin } from "../../../utils/getDataLogin";

const Get = (path) => {
  const promise = new Promise((resolve, reject) => {
    const config = {
      headers: { Authorization: `Bearer ${getDataLogin().token}` },
    };
    Axios.get(`${baseUrl}/${path}`, config).then(
      (result) => {
        resolve(result.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
  // console.log(token);
  return promise;
};

export default Get;
